import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import { BsGithub } from 'react-icons/bs';


const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/luca-baeck" target="_blank"><BsGithub/></a>
    </div>
    {/*
    <div>
      <a href="https://instagram.com/lucab__05"><BsInstagram/></a>
    </div>
    */} 
  </div>
);

export default SocialMedia;
